import { Typography } from '@mui/material';
import React from 'react';
import DashboardFrame from '../components/basic/DashboardFrame';
import MenuTest from '../components/basic/MenuList';
import strings from '../values/strings/strings';
import Monitoring from '../components/pagescomponents/Monitoring'
function Monitor(props) {
    return (
        <DashboardFrame title={strings.getString('screen_monitor_title')}>
            <Monitoring />
        </DashboardFrame>
    );
}

export default Monitor;